<div class="myunichoices-question question-type-choice">
  <h2 class="number" [innerHTML]="question.header | parseFormattedText"></h2>
  <div class="question">
    <div [innerHTML]="question.question | parseFormattedText" ngxBalanceText></div>
  </div>
  <div class="answer" data-step="1" [attr.data-intro]="locale.overlayIntroduction">
    <ul>
      <li *ngFor="let option of question.options">
        <app-round-button
          [ngClass]="{ selected: option.selected }"
          (click)="toggleSelection(option)"
          >{{ option.title }}</app-round-button
        >
      </li>
    </ul>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/questionnaire/questions/multi-choice/multi-choice.component.html